import axios from 'axios';

export default {
  summary: (params = {}, config = {}) => axios.get('financial-accounts/summary', { params, ...config }),
  list: (params = {}, config = {}) => axios.get('financial-accounts', { params, ...config }),
  store: (payload = {}, config = {}) => axios.post('financial-accounts', payload, config),
  show: (financialAccountId, config = {}) => axios.get(`financial-accounts/${financialAccountId}`, config),
  toggleStatus: (financialAccountId, payload = {}, config = {}) => axios.put(`financial-accounts/${financialAccountId}/status`, payload, config),
  detailSummary: (financialAccountId, params = {}, config = {}) => axios.get(`financial-accounts/${financialAccountId}/summary`, { params, ...config }),
  syncBalances: (payload = {}, config = {}) => axios.post('financial-accounts/sync-balances', payload, config),
  update: (financialAccountId, payload = {}, config = {}) => axios.put(`financial-accounts/${financialAccountId}`, payload, config),
  delete: (financialAccountId, config = {}) => axios.delete(`financial-accounts/${financialAccountId}`, config),
  movements: (financialAccountId, params = {}, config = {}) => axios.get(`financial-accounts/${financialAccountId}/movements`, { params, ...config }),
  activity: (financialAccountId, params = {}, config = {}) => axios.get(`financial-accounts/${financialAccountId}/activity`, { params, ...config }),
  history: (params = {}, config = {}) => axios.get('financial-accounts/history', { params, ...config }),
  selectors: (params = {}, config = {}) => axios.get('financial-accounts/selectors', { params, ...config }),
  exportColumns: (config = {}) => axios.get('financial-accounts/exports/columns', config),
  exportFormats: (config = {}) => axios.get('financial-accounts/exports/formats', config),
  exportFormatStore: (payload = {}, config = {}) => axios.post('financial-accounts/exports/formats', payload, config),
  exportFormatUpdate: (formatId, payload = {}, config = {}) => axios.put(`financial-accounts/exports/formats/${formatId}`, payload, config),
  exportFormatDelete: (formatId, config = {}) => axios.delete(`financial-accounts/exports/formats/${formatId}`, config),
  exportExcel: (payload = {}, config = {}) => axios.post('financial-accounts/exports/excel', payload, {
    responseType: 'blob',
    ...config,
  }),
  exportPdf: (payload = {}, config = {}) => axios.post('financial-accounts/exports/pdf', payload, {
    responseType: 'blob',
    ...config,
  }),
};
